import styled from "@emotion/styled";
import {mq} from "@styles/helpers";
import {Devices} from "@styles/tokens";

export const StreakBadge = styled.div`
    position: relative;
    height:100%;
    width:100%;
    display:grid;
    grid-template-rows: 0.8fr 0.8fr 2.2fr 0.5fr 0.8fr;
`;

export const LottieContainer = styled.div<{animate:boolean, apear:boolean, hide:boolean}>`
    width:${props => props.animate?"65%":"80%"};
    pointer-events: none;
    position: absolute;
    bottom:${props => props.animate?"47%":"7.5%"};
    right:${props => props.animate?"50%":"12%"};
    transform: translate(50%, 50%) scale(${props => props.hide?"0":"1"});
    z-index: 2;
    transition: opacity 0.6s ease-in-out, width 0.6s ease-in-out, bottom  0.6s ease-in-out, right  0.6s ease-in-out, transform 1.2s ease-in-out;
    opacity: ${props => props.apear?"1":"0"};
`;